var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuotingcoverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 30.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9131"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8697",
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5713",
    d: "M6.75 6.25h18v18h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5714",
    d: "M17.85 19.75h2.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5715",
    d: "M17.85 17.5h2.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5716",
    d: "M9 15.25h13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5717",
    d: "M22.5 20.239A1.761 1.761 0 0120.739 22h-9.978A1.761 1.761 0 019 20.239v-9.978A1.761 1.761 0 0110.761 8.5h9.978a1.761 1.761 0 011.761 1.761z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5718",
    d: "M18 11.875h2.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5719",
    d: "M11.25 11.875h2.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5720",
    d: "M12.375 13v-2.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5721",
    d: "M11.58 17.83l1.59 1.59",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5722",
    d: "M11.58 19.42l1.59-1.59",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5723",
    d: "M15.75 8.5V22",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7315",
    d: "M15.25 29.75h0a14.5 14.5 0 01-14.5-14.5h0A14.5 14.5 0 0115.25.75h0a14.5 14.5 0 0114.5 14.5h0a14.5 14.5 0 01-14.5 14.5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

export default SvgQuotingcoverage;


//////////////////
// WEBPACK FOOTER
// ./src/icons/quoting coverage.svg
// module id = 872
// module chunks = 101